import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Vuetify from 'vuetify'
import axios from 'axios'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCoffee, faCouch, faShapes, faBook, faBath, faUtensils, faFirstAid, faPencilAlt, faShoppingBag, faTshirt, faSocks, faShoePrints, faVideo, faTags, faStar } from '@fortawesome/free-solid-svg-icons'
import App from './App.vue'
import router from 'app/router.js'
import VueHead from 'vue-head'
// import VueMeta from 'vue-meta'
import i18nMixin from 'app/mixins/i18n'
import { i18n } from './i18n/index.js'
import 'babel-polyfill'
import VueGtm from 'vue-gtm'
import VueLazyload from 'vue-lazyload'
import store from './app/store/index.js'
import VueGtag from 'vue-gtag'

export const bus = new Vue()

library.add(faCoffee, faCouch, faShapes, faBook, faBath, faUtensils, faFirstAid, faPencilAlt, faShoppingBag, faTshirt, faSocks, faShoePrints, faVideo, faTags, faStar)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(Vuetify)
// Vue.use(VueMeta) 서버사이드 랜더링 아니라서 동적으로 og 태그 추가 해도 반영 안되기때문에 다시 off.
Vue.use(VueHead)
Vue.use(VueLazyload, {
  lazyComponent: true
})

Vue.mixin(i18nMixin)

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: 'UA-114399237-4',
    router
  })
  Vue.use(VueGtm, {
    id: 'GTM-5Z29GMB',
    enabled: true,
    vueRouter: router
  })

  // Google Analytics 4 (GA4) 적용 부분
  // vue-analytics 는 GA4를 지원하지 않기 때문에 vue-gtag 사용
  Vue.use(VueGtag, {
    config: {
      id: 'G-X5VXFJ8LTH', // Google Analytics의 Tracking ID를 넣어준다
      params: { send_page_view: false }
    }
  }, router)
}
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

Vue.prototype.$http = axios
Vue.prototype.$language = i18n
Vue.prototype.$eventBus = new Vue()

new Vue({
  store,
  el: '#app',
  i18n,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js